import { useMutation } from "@/compat/reactQuery";
import caseNestUserAlertSettingService from "../../services/caseNestUserAlertSettingService";

const useAddCaseNestUserAlertSetting = () =>
  useMutation(caseNestUserAlertSettingService.create);

export default useAddCaseNestUserAlertSetting;